import { render } from "./OnlineSolutions.vue?vue&type=template&id=2e395344"
import script from "./OnlineSolutions.vue?vue&type=script&lang=js"
export * from "./OnlineSolutions.vue?vue&type=script&lang=js"

import "./OnlineSolutions.vue?vue&type=style&index=0&id=2e395344&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__